import React, { forwardRef, useMemo } from 'react'
import { Uniform } from 'three'
import { Effect } from 'postprocessing'

const fragmentShader = `
uniform sampler2D uTextureTo;
uniform float uProgress;
uniform float zoom_quickness;

vec2 zoom(vec2 uv, float amount) {
  return 0.5 + ((uv - 0.5) * (smoothstep(1.0, 0.2, 0.8*amount)));	
}

void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {
  float zoomAmount = smoothstep(0.0, 1.0, uProgress);
  vec2 fromTexCoord = zoom(uv, zoomAmount);

  vec4 fromColor = texture2D(inputBuffer, fromTexCoord);
  vec4 toColor = texture2D(uTextureTo, uv);
  
  float mixAmount = smoothstep(0.2, 0.8, uProgress);  
  outputColor = mix(fromColor, toColor, mixAmount);
}
`;

class MyTransitionEffect extends Effect {
    constructor({ textureTo, progress, zoom_quickness = 0.3 }) {
        super('MyTransitionEffect', fragmentShader, {
            uniforms: new Map([
                ['uTextureTo', new Uniform(textureTo)],
                ['uProgress', new Uniform(progress)],
                ['zoom_quickness', new Uniform(zoom_quickness)],
            ]),
        });
    }
}

export const TransitionEffect = forwardRef(({ textureTo }, ref) => {
    const effect = useMemo(() => new MyTransitionEffect({
        textureTo,
        progress: 0
    }), []);

    return (<primitive ref={ref} object={effect} dispose={null} />)
})